if (window.__modalJsLoaded) {
} else {
window.__modalJsLoaded = true;
window.modal = {
  init: function () {
    // closing through overlay click
    document.querySelectorAll(".modal-overlay").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (e.target.closest(".modal")) {
          return;
        }
        this.classList.remove("show-modal");
      });
    });

    // closing through close button click
    document
      .querySelectorAll(".modal-close, .modal-close-button")
      .forEach(function (el) {
        el.addEventListener("click", function () {
          this.closest(".modal-overlay").classList.remove("show-modal");
        });
      });

    // selecting an offer
    document
      .querySelectorAll(".modal .offers button")
      .forEach(function (clickedOfferButton) {
        clickedOfferButton.addEventListener("click", function () {
          this.closest(".offers")
            .querySelectorAll("button")
            .forEach(function (offerButton) {
              offerButton.classList.remove("selected");
            });
          this.classList.add("selected");
          // also, if in gift modal - activate the submit button
          this.closest(".gift-modal")
            ?.querySelector(".button")
            .classList.add("active");
        });
      });

    // month toggle
    document.querySelectorAll(".month-toggle p").forEach(function (toggle) {
      const giftInfoModal = toggle.closest(".gift-info-modal");
      const isLower = toggle.classList.contains("three");
      toggle.addEventListener("click", function () {
        giftInfoModal
          .querySelectorAll(".modal-header")
          .forEach(function (modalHeader) {
            if (
              (modalHeader.classList.contains("modal-header-lower") &&
                isLower) ||
              (modalHeader.classList.contains("modal-header-higher") &&
                !isLower)
            ) {
              modalHeader.style.display = "block";
            } else {
              modalHeader.style.display = "none";
            }
          });
        giftInfoModal
          .querySelector(".month-toggle .three")
          .classList.toggle("selected", isLower);
        giftInfoModal
          .querySelector(".month-toggle .six")
          .classList.toggle("selected", !isLower);
      });
    });

    // gift modal - submit
    document
      .querySelectorAll(".gift-modal a.button")
      .forEach(function (button) {
        const giftModal = button.closest(".gift-modal");
        button.addEventListener("click", function (e) {
          e.stopPropagation();
          const giftVariantId = giftModal.querySelector(
            ".offers button.selected"
          )?.dataset.gid;
          const cartItemJSON = giftModal.dataset.cartItem;
          if (!giftVariantId || !cartItemJSON) {
            return false;
          }
          const cartItem = JSON.parse(cartItemJSON);
          window.priceSelectorV2.addToCart(cartItem, giftVariantId);
          return false;
        });
      });


    // benefits modal
    document.querySelectorAll(".benefits-link").forEach(function (link) {
      link.addEventListener("click", function () {
        document
          .querySelector(".benefits-modal-overlay")
          ?.classList.add("show-modal");
      });
    });

    // product-popup modal
    this.setProductModalEvents();
  },

  setProductModalEvents: function() {
    const openProductModal = (e) => {
      const modalOverlay = e.currentTarget.closest('.card-wrapper')?.querySelector('.product-modal-overlay');
      modalOverlay?.classList.add('show-modal');
      modalOverlay?.querySelector('product-popup')?.updateGallery();
    };

    document.querySelectorAll(".js-open-product-modal").forEach(function (linkEl) {
      linkEl.removeEventListener('click', openProductModal);
      linkEl.addEventListener('click', openProductModal);
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  window.modal.init();
});

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.complementary-products .js-open-product-modal');
  if (btn) {
    const cardWrapper = btn.closest('.card-wrapper');
    const modalOverlay = cardWrapper?.querySelector('.product-modal-overlay');
    if (modalOverlay) {
      modalOverlay.classList.add('show-modal');
      window.modal.init();
      window.priceSelectorV2.init();

      // If your product-popup has an updateGallery method, call it
      modalOverlay.querySelector('product-popup')?.updateGallery?.();
    }
  }
});

// Event delegation for product modal buttons (works with dynamic content)
//document.addEventListener('click', function(e) {
//  const btn = e.target.closest('.js-open-product-modal');
//  if (btn) {
//    const cardWrapper = btn.closest('.card-wrapper');
//    const modalOverlay = cardWrapper?.querySelector('.product-modal-overlay');
//    if (modalOverlay) {
//      modalOverlay.classList.add('show-modal');
//      // If your product-popup has an updateGallery method, call it
//      modalOverlay.querySelector('product-popup')?.updateGallery?.();
//    }
//  }
//});
}
